const communityTabItems = ['/about', '/assets', '/feed'] as const;

export type CommunityTabItem = (typeof communityTabItems)[number];

export const isCommunityTabItem = (value?: unknown): value is CommunityTabItem =>
  typeof value === 'string' && (communityTabItems as readonly string[]).includes(value);
